import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ClinicLogo from '../Practice/Logo';
import StryderStationery from '../Stryder/components/Stationery/StryderStationery';
import { PracticeRoutes } from '../common/PracticeRoutes';
import { SERVER_VERSION, canLogin } from '../config';
import useServerConfig from '../hooks/useServerConfig';
import TopMenu from '../shared/TopMenu';
import Logo from '../Stryder/components/Logo/Logo';
import './host.css';

/** URL to marketing site. */
const STRYDER_MARKETING_URL = 'https://stryder.cloud';

/**
 * Simple component that displays *Home*. This is suitable for demonstrating
 * a simple non-logged-in view.
 */
const Home = () => {
  const { config } = useServerConfig();
  return (
    <>
      <StryderStationery
        menu={<TopMenu />}
        style={{ height: 'calc(100% - 16px)' }}
      >
        <Typography
          variant="caption"
          style={{ position: 'absolute', right: 16, bottom: 8, opacity: 0.5 }}
        >
          {SERVER_VERSION} {config?.COMMIT_SHA}
        </Typography>
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          style={{ height: 'calc(100% - 2em' }}
        >
          <Grid item></Grid>

          <Grid item>
            <Box alignContent="center">
              <a href={STRYDER_MARKETING_URL}>
                <Logo
                  style={{ display: 'block', width: '80%', margin: '0 10%' }}
                />
              </a>
            </Box>
            <p></p>
            <Typography>
              <a href={STRYDER_MARKETING_URL}>Stryder</a> is a plugin for third
              party Electronic Medical Records, developed to improve efficiency
              and accuracy in workflows and enhance the functionality of EMR
              systems through video analysis.
            </Typography>
            <p></p>
            {canLogin && (
              <Typography>
                Log in to Stryder using a sample Physical Therapy Practice
                below.
              </Typography>
            )}
          </Grid>
          <Grid item>
            {canLogin && (
              <Box alignContent="center" style={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  href={PracticeRoutes.HOME}
                >
                  <Grid container direction="column" alignItems="center">
                    <ClinicLogo
                      size={32}
                      style={{
                        background: 'white',
                        padding: 4,
                        borderRadius: 4
                      }}
                    />
                    <>Launch demo</>
                  </Grid>
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
      </StryderStationery>
    </>
  );
};
export default Home;
